import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLaporanList } from '@/hooks/useKegiatan'
import { useAuth } from '@/hooks/useAuth'
import { format } from 'date-fns'
import { id } from 'date-fns/locale'
import TabBar from '@/components/ui/TabBar'
import Card from '@/components/ui/Card'
import Badge from '@/components/ui/Badge'
import EmptyState from '@/components/ui/EmptyState'
import Button from '@/components/ui/Button'

export default function LaporanListPage() {
  const navigate = useNavigate()
  const { isSuperAdmin, isAnggota } = useAuth()
  const [tab, setTab] = useState('kegiatan')
  const [publishedOnly, setPublishedOnly] = useState(true)

  const { data, isLoading } = useLaporanList({
    published: isAnggota ? true : publishedOnly ? true : undefined,
    jenis: tab,
  })

  const items = data?.items || []

  const tabs = [
    { key: 'kegiatan', label: 'Kegiatan' },
    { key: 'evaluasi', label: 'Evaluasi' },
    { key: 'keuangan', label: 'Keuangan' },
    { key: 'monev', label: 'Monev' },
  ]

  return (
    <div className="py-4 space-y-4">
      <TabBar tabs={tabs} activeTab={tab} onChange={setTab} />

      {isSuperAdmin && (
        <div className="flex gap-2 items-center">
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input
              type="checkbox"
              checked={publishedOnly}
              onChange={(e) => setPublishedOnly(e.target.checked)}
              className="w-4 h-4 accent-primary"
            />
            <span>Hanya yang dipublish</span>
          </label>
          <Button
            size="sm"
            className="ml-auto"
            onClick={() => navigate('/laporan/new')}
          >
            + Buat Laporan
          </Button>
        </div>
      )}

      {isLoading ? (
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white rounded-card h-24 animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <EmptyState
          title="Belum ada laporan"
          description={isSuperAdmin ? 'Buat laporan pertama Anda.' : 'Tidak ada laporan yang dipublish.'}
        />
      ) : (
        items.map((l) => (
          <Card
            key={l.id}
            onClick={() => navigate(`/laporan/viewer/${l.id}`)}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex gap-1.5 mb-1">
                  <Badge variant="primary">{l.jenis}</Badge>
                  {l.published && <Badge variant="green">Published</Badge>}
                </div>
                <h3 className="text-sm font-bold text-text-primary truncate">{l.judul}</h3>
                <p className="text-xs text-text-secondary mt-0.5">
                  {format(new Date(l.created), 'dd MMM yyyy', { locale: id })}
                  {(l.expand?.kegiatan as { judul?: string })?.judul && (
                    <> — {(l.expand?.kegiatan as { judul?: string }).judul}</>
                  )}
                </p>
              </div>
              <svg className="w-5 h-5 text-text-secondary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </Card>
        ))
      )}
    </div>
  )
}
